import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import Fireworks from "react-canvas-confetti/dist/presets/fireworks";
import type { TConductorInstance } from "react-canvas-confetti/dist/types";

export interface ConfettiHandle {
  celebrate: () => void;
}

export const Confetti = forwardRef<ConfettiHandle>(function Confetti(_, ref) {
  const conductor = useRef<TConductorInstance | null>(null);
  const timers = useRef<ReturnType<typeof setTimeout>[]>([]);

  useEffect(() => () => timers.current.forEach(clearTimeout), []);

  useImperativeHandle(ref, () => ({
    celebrate() {
      timers.current.forEach(clearTimeout);
      conductor.current?.shoot();
      timers.current = [400, 800].map((delay) =>
        setTimeout(() => conductor.current?.shoot(), delay),
      );
    },
  }));

  return (
    <Fireworks
      onInit={({ conductor: instance }) => {
        conductor.current = instance;
      }}
      globalOptions={{ resize: true, disableForReducedMotion: true }}
    />
  );
});
